export default __webpack_public_path__ + "static/media/Inbox.ffa4bff6.svg";